import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const recensioniJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Article',
      '@id': 'https://itaobuyspread.top/recensioni-itaobuy-spreadsheet/#article',
      headline: 'Itaobuy Spreadsheet Recensioni: Cosa Dicono gli Utenti Italiani',
      description: 'Raccolta di recensioni reali degli utenti italiani su Itaobuy Spreadsheet. Scopri le esperienze autentiche della community.',
      image: 'https://readdy.ai/api/search-image?query=Happy%20Italian%20customers%20sharing%20their%20positive%20shopping%20experiences%2C%20warm%20natural%20lighting%2C%20modern%20cafe%20setting%20with%20cream%20walls%20and%20terracotta%20accents%2C%20genuine%20authentic%20expressions%2C%20people%20looking%20at%20laptop%20together%2C%20Mediterranean%20lifestyle%20scene%2C%20relaxed%20atmosphere%2C%20editorial%20photography%2C%20warm%20earth%20tones%2C%20community%20and%20trust%20concept&width=1200&height=600&seq=recensioni-hero&orientation=landscape',
      author: { '@type': 'Organization', name: 'Itaobuy Team', url: 'https://itaobuyspread.top' },
      publisher: { '@id': 'https://itaobuyspread.top/#organization' },
      mainEntityOfPage: { '@type': 'WebPage', '@id': 'https://itaobuyspread.top/recensioni-itaobuy-spreadsheet' },
      datePublished: '2026-07-14',
      dateModified: '2026-07-14',
      inLanguage: 'it',
      isPartOf: { '@id': 'https://itaobuyspread.top/#website' },
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://itaobuyspread.top' },
        { '@type': 'ListItem', position: 2, name: 'Recensioni', item: 'https://itaobuyspread.top/recensioni-itaobuy-spreadsheet' },
      ],
    },
  ],
};

export default function RecensioniPage() {
  return (
    <>
      <Navbar />
      <main>
        <article>
          <header className="pt-32 pb-16 md:pt-40 md:pb-20 px-6 md:px-10 bg-background-50">
            <div className="max-w-4xl mx-auto text-center">
              <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-semibold tracking-wide uppercase mb-5">
                Recensioni
              </span>
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-6">
                Itaobuy Spreadsheet Recensioni: Cosa Dicono gli Utenti Italiani
              </h1>
              <div className="flex items-center justify-center gap-4 text-sm text-foreground-500">
                <span>Da Itaobuy Team</span>
                <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                <span>Aggiornato: Luglio 2026</span>
                <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                <span>10 min di lettura</span>
              </div>
            </div>
          </header>

          <div className="max-w-4xl mx-auto px-6 md:px-10">
            <div className="mb-12 overflow-hidden rounded-[32px]">
              <img
                src="https://readdy.ai/api/search-image?query=Happy%20Italian%20customers%20sharing%20their%20positive%20shopping%20experiences%2C%20warm%20natural%20lighting%2C%20modern%20cafe%20setting%20with%20cream%20walls%20and%20terracotta%20accents%2C%20genuine%20authentic%20expressions%2C%20people%20looking%20at%20laptop%20together%2C%20Mediterranean%20lifestyle%20scene%2C%20relaxed%20atmosphere%2C%20editorial%20photography%2C%20warm%20earth%20tones%2C%20community%20and%20trust%20concept&width=1200&height=600&seq=recensioni-hero&orientation=landscape"
                alt="Itaobuy Spreadsheet recensioni utenti italiani"
                title="Itaobuy Spreadsheet - Recensioni degli Utenti"
                className="w-full aspect-[2/1] object-cover object-top"
              />
            </div>

            <div className="prose prose-lg max-w-none mb-16">
              <section className="mb-14">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">
                  La Voce della Community Italiana
                </h2>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  Abbiamo raccolto le <strong>recensioni pi&ugrave; significative</strong> degli utenti italiani che utilizzano Itaobuy Spreadsheet quotidianamente. Queste sono esperienze reali, non filtrate, che ti danno un quadro onesto di cosa significhi usare questo strumento.
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  <Link to="/" className="text-primary-600 font-semibold hover:text-primary-700 underline underline-offset-4">
                    Torna alla homepage di Itaobuy Spreadsheet
                  </Link> per vedere tutte le risorse disponibili.
                </p>
              </section>

              <div className="space-y-6 mb-14">
                {[
                  { name: 'Alessandro B.', city: 'Roma', rating: 5, text: 'Ho scoperto Itaobuy Spreadsheet tre mesi fa e ha completamente cambiato il mio approccio allo shopping online. Prima passavo ore a cercare recensioni sparse, ora ho tutto in un unico foglio organizzato. Le foto QC sono il vero punto di forza: vedi esattamente cosa compri.' },
                  { name: 'Giulia M.', city: 'Milano', rating: 5, text: 'Sono una fashion blogger e uso Itaobuy Spreadsheet per trovare capi unici da recensire. La qualit&agrave; dei prodotti &egrave; costantemente alta e i venditori sono affidabili. Apprezzo particolarmente gli aggiornamenti settimanali che mi tengono sempre al passo con le novit&agrave;.' },
                  { name: 'Francesco R.', city: 'Napoli', rating: 5, text: 'Ero scettico all&apos;inizio, ma dopo il primo acquisto andato a buon fine mi sono ricreduto. Ho gi&agrave; fatto 5 ordini utilizzando lo spreadsheet e non ho mai avuto problemi. Il confronto prezzi mi ha fatto risparmiare almeno il 30%.' },
                  { name: 'Sofia L.', city: 'Torino', rating: 4, text: 'Ottimo strumento per chi come me cerca prodotti di nicchia. L&apos;unico consiglio che darei &egrave; di aggiungere pi&ugrave; categorie per l&apos;abbigliamento donna. Per il resto, funziona perfettamente e il supporto della community &egrave; eccezionale.' },
                  { name: 'Lorenzo P.', city: 'Firenze', rating: 5, text: 'Uso Itaobuy Spreadsheet da sei mesi e ho costruito un guardaroba praticamente nuovo spendendo la met&agrave; di quanto avrei speso nei negozi tradizionali. Le sneakers che ho preso sono identiche alle foto QC. Consigliatissimo!' },
                  { name: 'Valentina D.', city: 'Bologna', rating: 5, text: 'La parte migliore &egrave; la trasparenza. Sai esattamente cosa stai comprando, quanto costa, chi lo vende e cosa ne pensano gli altri. Nessuna sorpresa. Finalmente uno strumento che mette il consumatore al centro.' },
                  { name: 'Matteo C.', city: 'Venezia', rating: 4, text: 'Buonissima esperienza complessiva. Ho trovato accessori che non avrei mai scoperto da solo. A volte i tempi di spedizione sono un po&apos; lunghi, ma viene specificato chiaramente nello spreadsheet quindi puoi organizzarti.' },
                ].map((review, i) => (
                  <div key={i} className="p-6 rounded-2xl bg-background-50 border border-background-200/60">
                    <div className="flex items-start justify-between mb-3">
                      <div>
                        <p className="font-semibold text-foreground-950">{review.name}</p>
                        <p className="text-xs text-foreground-500">{review.city}</p>
                      </div>
                      <div className="flex items-center gap-0.5">
                        {[...Array(5)].map((_, j) => (
                          <i key={j} className={`ri-star-fill text-sm ${j < review.rating ? 'text-accent-500' : 'text-foreground-200'}`}></i>
                        ))}
                      </div>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed italic">&ldquo;{review.text}&rdquo;</p>
                  </div>
                ))}
              </div>

              <section className="mb-14">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">
                  Cosa Emerge dalle Recensioni
                </h2>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  Dalle recensioni emergono alcuni temi ricorrenti: <strong>trasparenza</strong>, <strong>risparmio di tempo</strong>, <strong>qualit&agrave; dei prodotti</strong> e <strong>affidabilit&agrave; dei venditori</strong>. La community italiana apprezza particolarmente le foto QC e la possibilit&agrave; di confrontare facilmente i prezzi.
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  <Link to="/" className="text-primary-600 font-semibold hover:text-primary-700 underline underline-offset-4">
                    Unisciti alla community su Itaobuy Spreadsheet Italia
                  </Link> e condividi anche tu la tua esperienza.
                </p>
              </section>
            </div>

            <div className="mb-20 p-8 rounded-[28px] bg-primary-500 text-center">
              <h3 className="font-heading text-2xl font-bold text-background-50 mb-3">
                Prova Anche Tu Itaobuy Spreadsheet
              </h3>
              <p className="text-primary-100 mb-6 max-w-lg mx-auto">
                Unisciti a migliaia di acquirenti soddisfatti. La tua prossima recensione positiva ci aspetta.
              </p>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-background-50 text-sm font-semibold text-primary-600 hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap"
              >
                Itaobuy Sheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>

          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(recensioniJsonLd),
            }}
          />
        </article>
      </main>
      <Footer />
    </>
  );
}